import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("admin_token");
      if (window.location.pathname.startsWith("/admin") && 
          window.location.pathname !== "/admin/login") {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (username, password) =>
  api.post("/auth/login", { username, password });

export const getMe = () => api.get("/auth/me");

// Servicios
export const getServicios = (soloActivos = false) =>
  api.get("/servicios", { params: { solo_activos: soloActivos } });

export const getServicio = (id) => api.get(`/servicios/${id}`);

export const createServicio = (data) => api.post("/servicios", data);

export const updateServicio = (id, data) => api.put(`/servicios/${id}`, data);

export const deleteServicio = (id) => api.delete(`/servicios/${id}`);

// Peluqueros
export const getPeluqueros = (soloActivos = false) =>
  api.get("/peluqueros", { params: { solo_activos: soloActivos } });

export const getPeluquero = (id) => api.get(`/peluqueros/${id}`);

export const createPeluquero = (data) => api.post("/peluqueros", data);

export const updatePeluquero = (id, data) => api.put(`/peluqueros/${id}`, data);

export const deletePeluquero = (id) => api.delete(`/peluqueros/${id}`);

// Disponibilidad
export const getDisponibilidad = (servicioId, fecha, peluqueroId = null) =>
  api.get("/disponibilidad", {
    params: { servicio_id: servicioId, fecha, peluquero_id: peluqueroId },
  });

// Próximos huecos disponibles
export const getProximosHuecos = (servicioId, cantidad = 10) =>
  api.get("/proximos-huecos", {
    params: { servicio_id: servicioId, cantidad },
  });

// Días con al menos un hueco disponible (para el calendario)
export const getDiasDisponibles = (servicioId, peluqueroId = null, dias = 22) =>
  api.get("/dias-disponibles", {
    params: { servicio_id: servicioId, peluquero_id: peluqueroId, dias },
  });

// Citas
export const getCitas = (params = {}) => api.get("/citas", { params });

export const getCita = (id) => api.get(`/citas/${id}`);

export const createCita = (data) => api.post("/citas", data);

export const updateCita = (id, data) => api.put(`/citas/${id}`, data);

export const cancelarCita = (id, codigo = null) =>
  api.post(`/citas/${id}/cancelar`, null, { params: { codigo } });

export const deleteCita = (id) => api.delete(`/citas/${id}`);

// Cancelar por nombre + teléfono (público)
export const buscarCitasParaCancelar = (nombre, telefono) =>
  api.get("/mis-citas-cancelar", { params: { nombre, telefono } });

export const cancelarCitaPublica = (citaId, nombre, telefono) =>
  api.post(`/cancelar-cita/${citaId}`, null, { params: { nombre, telefono } });

// Admin Citas
export const createCitaAdmin = (data) => api.post("/admin/citas", data);

export const moverCita = (id, nuevaFecha, nuevaHora, nuevoPeluqueroId = null) =>
  api.put(`/admin/citas/${id}/mover`, null, {
    params: {
      nueva_fecha: nuevaFecha,
      nueva_hora: nuevaHora,
      nuevo_peluquero_id: nuevoPeluqueroId,
    },
  });

// Buscar mis citas (público)
export const buscarMisCitas = (nombre, telefono) =>
  api.get("/mis-citas", { params: { nombre, telefono } });

// Clientes (simplificado)
export const getClientes = () => api.get("/clientes");

export const deleteCliente = (id) => api.delete(`/clientes/${id}`);

// Bloqueos
export const getBloqueos = (params = {}) => api.get("/bloqueos", { params });

export const createBloqueo = (data) => api.post("/bloqueos", data);

export const deleteBloqueo = (id) => api.delete(`/bloqueos/${id}`);

// Configuración
export const cambiarCredenciales = (data) => api.put("/auth/cambiar-credenciales", data);

export const getConfiguracion = () => api.get("/configuracion");

export const updateConfiguracion = (data) => api.put("/configuracion", data);

export default api;
